module.exports = __webpack_public_path__ + "media/images/athletes/3413-adb906b7e0bb406b5b71e0c4fe8dc808.png";